export default __webpack_public_path__ + "static/media/Pattanayak.9ac5d728.png";